import { useTranslate } from '@refinedev/core';
import { Card, Descriptions } from 'antd';
import type { DescriptionsProps } from 'antd';
import type { OrganizationOut } from '@/api/generated/schemas';
import { orDash, useVerticalDescProps } from '@/components/common/show/shared';
import { OrganizationStatusTag } from '@/components/tenancy/tags';
import { formatDateTime } from '@/utils/format';

interface OrganizationGeneralTabProps {
  record: OrganizationOut;
}

export const OrganizationGeneralTab = ({
  record,
}: OrganizationGeneralTabProps) => {
  const t = useTranslate();
  const verticalDescProps = useVerticalDescProps();

  const items: DescriptionsProps['items'] = [
    {
      key: 'id',
      label: t('base.fields.id'),
      children: orDash(record.id),
    },
    {
      key: 'name',
      label: t('tenancy.organizations.fields.name'),
      children: orDash(record.name),
    },
    {
      key: 'status',
      label: t('tenancy.organizations.fields.status'),
      children: <OrganizationStatusTag status={record.status} />,
    },
    {
      key: 'created_at',
      label: t('base.fields.created_at'),
      children: orDash(formatDateTime(record.created_at)),
    },
    {
      key: 'updated_at',
      label: t('base.fields.updated_at'),
      children: orDash(formatDateTime(record.updated_at)),
    },
  ];

  return (
    <Card title={t('base.sections.basic_info')}>
      <Descriptions
        {...verticalDescProps}
        column={{ xs: 1, sm: 2, md: 3 }}
        items={items}
      />
    </Card>
  );
};
